import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import withTrackingPropsProvider from '../../../hocs/withTrackingPropsProvider';

const MastheadContainer = styled.div`
  width: 100%;
  align-items: center;
  display: flex;
  height: 4.5rem;
  padding: 0 1.5rem 0 1rem;
  justify-content: space-between;
`;

const MastheadSection = styled.div`
  width: 33%;
  display: flex;
  justify-content: ${({ justifyContent }) =>
    justifyContent ? justifyContent : 'initial'};
`;

const TrackedMastheadContainer = withTrackingPropsProvider(MastheadContainer);

const TRACKING_PROPS = {
  block_name: 'masthead',
  block_row: 'masthead',
};

export default class Masthead extends Component {
  static displayName = 'Masthead';

  static propTypes = {
    left: PropTypes.element,
    center: PropTypes.element,
    right: PropTypes.element,
  };

  render() {
    const { left, center, right } = this.props;

    return (
      <TrackedMastheadContainer tracking={TRACKING_PROPS}>
        <MastheadSection justifyContent="flex-start">{left}</MastheadSection>
        <MastheadSection justifyContent="center">{center}</MastheadSection>
        <MastheadSection justifyContent="flex-end">{right}</MastheadSection>
      </TrackedMastheadContainer>
    );
  }
}
